import { BasemapProvider } from "../providerTypes";
export const customTileProvider: BasemapProvider={id:"customTile",label:"Custom tile URL",external:true,defaults:{provider:"customTile",enabled:false,tileUrl:"",attribution:"",maxZoom:19}};
